import { loadAppConfig } from './config/appConfig';
import { installNgrokFetchPatch } from './config/installNgrokFetchPatch';

installNgrokFetchPatch();

async function start() {
  try {
    await loadAppConfig();
    await import('./bootstrap');
  } catch (error) {
    console.error('Application startup failed:', error);
    const root = document.getElementById('root');
    if (root) {
      root.textContent = 'Сайтът не успя да се зареди. Моля, опитайте отново по-късно.';
    }
  }
}

void start();
